const BANNER_IMAGE = "/company-banner.webp";

export function CompanyBanner() {
  return (
    <section className="">
      {/* 배경 이미지 + 제목 */}
      <div
        className="h-[163px] tablet:h-[307px] desktop:h-[324px] bg-cover bg-center"
        style={{
          backgroundImage: `url(${BANNER_IMAGE}), linear-gradient(to bottom, #EDF5FF, #FCFCFF)`,
        }}
      >
        <div className="pt-6 tablet:pt-20 px-4 tablet:px-8 desktop:px-0 max-w-[1150px] mx-auto">
          <h1 className="text-heading-1-mb desktop:text-heading-1 text-[#212121]">
            변호사 소개
          </h1>
          <p className="text-heading-3-mb desktop:text-heading-3 pt-[10px] text-[#616269]">
            ESG 철학을 법과 채권회수 기술에 적용하다
          </p>
        </div>
      </div>

      {/* 설명 */}
      <div className="bg-[#FCFCFF] px-4 tablet:px-8  desktop:px-0  pt-[10px] pb-[76px]">
        <div className="max-w-[1150px] mx-auto text-[#616269] text-body-1-mb desktop:text-body-1">
          우리 사회는 채권회수, 법률서비스의 벽이 너무 높았습니다. 우리
          구성원들은 어떤 금액이라도 정당한 선의의 채권자의 채권은 지켜줘야
          한다고 믿습니다.
        </div>
      </div>
    </section>
  );
}
